import React from "react";
import SignUpInvestor from "./SignUpInvestor/SignUpInvestor";
// Select Action
const Investors = ({ properties, onCloseModal }) => {
  const { action } = properties;
  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      {(() => {
        switch (action) {
          case "signupinvestor":
            return (
              <SignUpInvestor
                properties={properties}
                onCloseModal={onCloseModal}
              />
            );

          default:
            return null;
        }
      })()}
    </div>
  );
};

export default Investors;
